
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report/[slug]",
      function () {
        return require("private-next-pages/report/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report/[slug]"])
      });
    }
  